export function to12Hour(timeStr) {
    if (!timeStr) return "";

    const [hour, minute] = timeStr.split(":").map(Number);

    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minute.toString().padStart(2, "0")} ${suffix}`;
}